import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useNotify } from '@/hooks'
import { UpdateSellTreezRequest } from '@/models/sellTreez'
import { SellTreezService } from '@/services/sell-treez'

const useUpdateSellTreez = (onSuccess?: () => void) => {
  const { notifySuccess, notifyError } = useNotify()
  const queryClient = useQueryClient()

  const update = async (data: UpdateSellTreezRequest): Promise<boolean> => {
    const response = await SellTreezService.updateSellTreez(data, data.id)
    return Boolean(response.data)
  }

  const { mutate: updateSellTreez, isPending: isUpdating } = useMutation({
    mutationFn: update,
    onSuccess: (_, { id }) => {
      queryClient.refetchQueries({ queryKey: ['sell-treez', id] })
      onSuccess?.()
      notifySuccess('SellTreez updated successfully')
    },
    onError: (error) => {
      console.error('Error updating SellTreez:', error)
      notifyError(`Error updating SellTreez`)
    },
  })

  return { updateSellTreez, isUpdating }
}

export { useUpdateSellTreez }
